import React from 'react';
import styled from 'styled-components';
import { Box } from 'pcln-design-system';
import { useAccordionState } from './AccordionProvider';
const CollapsibleSection = /*#__PURE__*/styled(Box).withConfig({
  displayName: "AccordionContent__CollapsibleSection",
  componentId: "sc-r9aoyr-0"
})(["max-height:", ";height:auto;overflow:", ";", ""], ({
  open
}) => open ? '100vh' : 0, ({
  open
}) => open ? 'hidden scroll' : 'hidden', ({
  shouldAnimate
}) => shouldAnimate ? 'transition: max-height 0.4s;' : null);
const AccordionContent = ({
  children,
  className,
  ...props
}) => {
  const {
    open,
    shouldAnimate,
    shouldMapOpenPropToContent
  } = useAccordionState();
  return React.createElement(CollapsibleSection, {
    open: open,
    shouldAnimate: shouldAnimate,
    className: className,
    "data-testid": 'CollapsibleSection',
    "aria-hidden": !open
  }, React.createElement(Box, {
    ...props
  }, shouldMapOpenPropToContent ? React.Children.map(children, child => React.cloneElement(child, {
    isAccordionOpen: open
  })) : children));
};
export default AccordionContent;